/**
 * geometry.ts
 * Utilitaires géométriques pour les transformations (rotation, scale, etc.)
 */

/**
 * Convertit des degrés en radians
 */
export function degToRad(deg: number) {
  return (deg * Math.PI) / 180;
}

/**
 * Fait tourner un vecteur (x, y) d'un angle donné en degrés
 */
export function rotateVec(x: number, y: number, angleDeg: number) {
  const a = degToRad(angleDeg);
  const cos = Math.cos(a);
  const sin = Math.sin(a);
  return { x: x * cos - y * sin, y: x * sin + y * cos };
}

/**
 * Fait tourner un point (px, py) autour d'un centre (cx, cy) d'un angle donné en degrés
 */
export function rotatePointAround(
  px: number,
  py: number,
  cx: number,
  cy: number,
  angleDeg: number
) {
  const dx = px - cx;
  const dy = py - cy;
  const v = rotateVec(dx, dy, angleDeg);
  return { x: cx + v.x, y: cy + v.y };
}

/**
 * Clamp une valeur entre min et max
 */
export function clamp(n: number, min: number, max: number) {
  return Math.max(min, Math.min(max, n));
}
